import { render } from "./sOmicsResult.vue?vue&type=template&id=1f7fe5e7&scoped=true"
import script from "./sOmicsResult.vue?vue&type=script&lang=js"
export * from "./sOmicsResult.vue?vue&type=script&lang=js"

import "./sOmicsResult.vue?vue&type=style&index=0&id=1f7fe5e7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7fe5e7"]])

export default __exports__